<script>
import { geoOrthographic, geoPath, geoGraticule } from 'd3-geo';
import rawLand from '../data/ne_50m_land.json';

let { size = 88 } = $props();

// The source GeoJSON is wound opposite to d3-geo's spherical convention, so
// every polygon reads as covering the whole globe. Reverse each ring to fix it.
const reverseRing = r => r.slice().reverse();
const rewindGeom = g => {
    if (g.type === 'Polygon') return { ...g, coordinates: g.coordinates.map(reverseRing) };
    if (g.type === 'MultiPolygon')
        return { ...g, coordinates: g.coordinates.map(p => p.map(reverseRing)) };
    return g;
};
const land = { ...rawLand, geometries: rawLand.geometries.map(rewindGeom) };

// Niño 3.4 region: 170°W–120°W, 5°S–5°N
const REGION = { w: -170, e: -120, s: -5, n: 5 };
// Center the globe on the middle of the region
const center = [(REGION.w + REGION.e) / 2, (REGION.s + REGION.n) / 2];

const projection = $derived(
    geoOrthographic()
        .scale(size / 2 - 1)
        .translate([size / 2, size / 2])
        .rotate([-center[0], -center[1]])
);

const path = $derived(geoPath(projection));

const sphere = { type: 'Sphere' };
// Sparser graticule (every 30°) so the small globe stays uncluttered
const graticule = geoGraticule().step([30, 30])();

// Build the region box, densified so its edges curve along parallels/meridians
const ninoBox = (() => {
    const { w, e, s, n } = REGION;
    const step = 2;
    const pts = [];
    for (let lon = w; lon <= e; lon += step) pts.push([lon, s]);
    for (let lat = s; lat <= n; lat += step) pts.push([e, lat]);
    for (let lon = e; lon >= w; lon -= step) pts.push([lon, n]);
    for (let lat = n; lat >= s; lat -= step) pts.push([w, lat]);
    pts.push([w, s]);
    return { type: 'Polygon', coordinates: [pts.reverse()] };
})();

</script>

<svg class="globe" width={size} height={size} viewBox="0 0 {size} {size}" aria-label="Locator globe showing the Niño 3.4 region in the equatorial Pacific">
    <path class="ocean" d={path(sphere)}></path>
    <path class="graticule" d={path(graticule)}></path>
    <path class="land" d={path(land)}></path>
    <path class="nino-box" d={path(ninoBox)}></path>
</svg>

<style lang="scss">
@import '@/styles/variables';

.globe {
    display: block;
    overflow: visible;
}

.ocean {
    fill: #fff;
    stroke: $gray4;
    stroke-width: 1;
}

.graticule {
    fill: none;
    stroke: #d3dbe3;
    stroke-width: 0.4;
}

.land {
    fill: $gray5;
    stroke: none;
}

.nino-box {
    fill: none;
    stroke: $cnn-red;
    stroke-width: 1.2;
}
</style>
